var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "circle_svg__a",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.9,
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M8 4h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 4h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M16 4h4v4h-4zM4 8h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 8h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 8h4v4h-4zM4 12h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M8 12h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M16 12h4v4h-4zM4 16h4v4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 16h4v4H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 16h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 16h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "currentColor",
    style: {
      stroke: "var(--accent-stroke)",
      strokeWidth: "var(--accent-stroke-width)"
    }
  }));
};
export default SvgCircle;